export default "__VITE_ASSET__D8qein7R__"